export default "__VITE_ASSET__BOukqy$___"